// extracted by mini-css-extract-plugin
module.exports = {"container":"NavItem_container__2Tw2T"};